/* global $, sgData */

// We need to wait for DOM ready because this JavaScript file is included
// mid-way down the page, for reasons that are unexplainable by common sense.
$(function () {
  // Body reference.
  var $body = $('body');

  // Button reference.
  var $button = $('.js-to-top');

  // Header reference.
  var $header = $('.header');

  // The offset value for when the button should be displayed.
  var offset = $header.outerHeight() || 150;

  // If no button found then stop.
  if ($button.length === 0) {
    return;
  }

  // If the content height is less than 20% larger that the viewport height then stop.
  if (($body.outerHeight() / window.innerHeight) < 1.2) {
    return;
  }

  // Click event.
  $button.on('click', function () {
    // Animate to top with easing.

    var trackOptions = {
      opt_label: window.sgData.page.name,
      merchant: false,
    };

    window.SgTrackingCore.track.scrollTop({
      eventAction: 'clicked',
      eventLabel: window.sgData.page.name,
    });

    $('html, body').animate({
      scrollTop: 0,
    }, 'slow');
  });

  // Ready/Scroll event.
  $(window).on('ready resize scroll', function () {
    // Scroll Y distance is greater than header height.
    if (window.pageYOffset > offset) {
      $button.removeClass('hide');
    } else {
      $button.addClass('hide');
    }
  });
});



// WEBPACK FOOTER //
// ./Library/1.0/common/scroll-to-top.js